import React from 'react';
import { PATH_NAMES } from '~/ocab-services/personal-styling/constants';
import { services } from '~/ocab-services/services.constant';
import { EDIT_PROGRESS_BAR_ITEMS_FOR_MODE_V1, PROGRESS_BAR_ITEMS_FOR_MODE_V1 } from '~/ocab-services/personal-styling/config/progress-bar-items.config';

export const config = {
  v1: {
    PROGRESS_BAR_ITEMS: PROGRESS_BAR_ITEMS_FOR_MODE_V1,
    EDIT_PROGRESS_BAR_ITEMS: EDIT_PROGRESS_BAR_ITEMS_FOR_MODE_V1,
    editMode: {
      firstEditPagePath: PATH_NAMES.EDIT_DATE,
      hideEditDateTitle: true,
      hideGoBackButton: true,
    },
    selectDateTitle: 'Select a date',
    // eslint-disable-next-line react/prop-types
    subtitleComponent: ({ className }) => (
      <div className={className}>
        <p>Our appointments are carried out online so you can receive expert advice anywhere at a time that works for you.</p>
      </div>
    ),
    getSelectDateExternalPrevPath: (envConfig, appointmentTypeId) => envConfig.services[services.PERSONAL_STYLING.name].appointmentTypes[appointmentTypeId].landingPageUrl,
     AboutIntro: {
      title: 'About you',
      description: 'Tell us a little bit about yourself so your Personal Stylist can prepare for your appointment.',
    },
    AboutYou: {
      TimeSlot: {
        title: null,
      },
    },
    ReviewForm: {
      hideShopDetails: true,
    },
    BookingReview: {
      hideShopDetails: true,
      displayPropertyAddress: true,
    },
    ReviewIntro: {
      title: 'Review',
      description: 'Please review your details before you complete your appointment booking.',
    },
  },
};
